import BaseStore from '@src/utils/store/base-store';
import DropDownMenuStore from './dropDownMenu/store';
import { observable } from 'mobx';
import SelectStore from '@src/business-components/common-language-select/store';
import BGMStore from '@src/business-components/bgm/store';
import FollowUsStore from '@src/business-components/common-follow-us/store';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const pageLocalesData = getPageLocalesData();
const navListLocales = pageLocalesData.topBar.navList;

const lang = getLanguageByPath();

class NaviBarStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable MainStore;

  selectStore = new SelectStore();

  @observable currentIndex = 0;
  @observable isSticky = false;
  /**
   * 关注我的store
   * @type {FollowUsStore}
   */
  followUsStore = new FollowUsStore();
  @observable
  bgm = new BGMStore({
    audioSrc: 'https://static-www.mechabreak.com/MP4/20231204/20231122bgm.mp3',
    musicPlayIcon: require('./images/music-on.png'),
    musicPauseIcon: require('./images/music-off.png'),
    musicIconRotate: false
  });

  dropDownMenuStore = new DropDownMenuStore();
  @observable
  navList = [
    {
      id: '1',
      title: navListLocales[0].name
    },
    {
      id: '3',
      title: navListLocales[3].name
    },
    {
      title: navListLocales[4].name,
      id: '4'
    },
    {
      title: navListLocales[5].name,
      id: '5'
    },
    {
      title: navListLocales[6].name,
      id: '6'
    },
    {
      title: navListLocales[7].name,
      id: '7'
    }
  ];

  get homeLink() {
    return `//mechabreak.seasungames.com/${lang}/index.html#/`;
  }

  clickMenu = (index, item) => {
    this.currentIndex = index;
    this.MainStore.pageSwiper.baseSwiperStore.onChange(index);
  };
  use() {
    super.use();
  }
}

export default NaviBarStore;
